import PropTypes from "prop-types";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { IconX } from "@tabler/icons";
import ActionButton, { iconButtonSx } from "src/components/shared/ActionButton";
import { DownloadButton, FilePreviewPane, fileName, useFilePreview } from "src/pages/cases/FilePreview";

export { fileName };

// A private file (passport, photo, visa), large: images inline, PDFs in the
// browser's own viewer. The same preview as a case's documents: words while
// it opens, an honest message after 10 s, Download always. `open` fetches a
// file from somewhere else (a fee receipt); `action` is one more button;
// `subtitle` replaces the file's name under the title.
export default function FileViewer({ file, title, subtitle, onClose, open, action }) {
  const preview = useFilePreview(file, null, open);

  return (
    <Dialog open onClose={onClose} maxWidth="lg" fullWidth aria-labelledby="request-viewer-title">
      <DialogTitle id="request-viewer-title" sx={{ display: "flex", alignItems: "center", gap: 1, pr: 1.5 }}>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="h6" component="span" noWrap sx={{ display: "block" }}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary" noWrap>
            {subtitle || fileName(file)}
          </Typography>
        </Box>
        <IconButton aria-label="Close" onClick={onClose} sx={iconButtonSx}>
          <IconX size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ minHeight: 320, display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "action.hover" }}>
        <FilePreviewPane file={file} title={title} preview={preview} />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
        <DownloadButton file={file} url={preview.url} type={preview.type} open={open} />
        <Box sx={{ flex: 1 }} />
        <ActionButton onClick={onClose}>Close</ActionButton>
        {action}
      </DialogActions>
    </Dialog>
  );
}

FileViewer.propTypes = {
  file: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.func,
  action: PropTypes.node,
};
